import { Button } from 'ui/Button';
import styles from './ActionRequiredAlertChequeMobile.module.scss';
import { ReactComponent as IconAlert } from './img/iconAlert.svg';
import { ReactComponent as IconClose } from './img/iconClose.svg';
import { useState } from 'react';
import { enumerate } from 'utils/strActions';

export const ActionRequiredAlertChequeMobile = ({
  count,
  onClick,
}: {
  count: number;
  onClick: () => void;
}) => {
  const [hidden, setHidden] = useState(false);

  if (hidden) return null;
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.header_left}>
          <IconAlert />
          <span className={styles.header_title}>
            Есть непросмотренные аннулированные чеки
          </span>
        </div>
        <IconClose style={{ cursor: 'pointer' }} onClick={() => setHidden(true)} />
      </div>
      <div className={styles.body}>
        Нашли {count}{' '}
        {enumerate(count, [
          'новый аннулированный чек по заказу',
          'новых аннулированных чека по заказам',
          'новых аннулированных чеков по заказам',
        ])}
      </div>
      <Button
        className={styles.btn}
        onClick={() => {
          onClick();
          setHidden(true);
        }}
        theme='filed'>
        Перейти
      </Button>
    </div>
  );
};
